<div class="financeiro-dashboard">
  <header class="financeiro-cabecalho">
    <div>
      <h1>Financeiro {{balcao ? 'Balcão' : ''}}</h1>
      <p>Acompanhe vendas, recebimentos e desempenho em um só lugar.</p>
    </div>
    <div class="financeiro-acoes">
      <button type="button" class="btn-financeiro btn-secundario" (click)="exporteRelatorioCompleto()"
              [disabled]="exportandoRelatorio || carregando">
        <i class="fe-download"></i> {{exportandoRelatorio ? 'Gerando...' : 'Exportar'}}
      </button>
      <button type="button" class="btn-financeiro btn-primario" (click)="imprimaRelatorio()">
        <i class="fe-printer"></i> Imprimir
      </button>
    </div>
  </header>

  <section class="financeiro-filtros">
    <div class="filtros-titulo">
      <div>
        <i class="fe-filter icone-filtros"></i>
        <h2>Filtros <span>{{quantidadeFiltrosAtivos}} ativos</span></h2>
      </div>
      <div class="base-periodo">
        <label>Período baseado em:</label>
        <div class="seletor-segmentado" role="group" aria-label="Período baseado em">
          <button type="button" [class.ativo]="filtroRascunho.baseData === 'venda'"
                  (click)="altereBaseData('venda')">Venda/entrega</button>
          <button type="button" [class.ativo]="filtroRascunho.baseData === 'pagamento'"
                  title="Considera a data de pagamento do pedido. Vendas ainda não quitadas não entram no período."
                  (click)="altereBaseData('pagamento')">Pagamento (quitação)</button>
        </div>
      </div>
    </div>

    <div class="filtros-periodo-horizontal">
      <div class="periodo-rapido-grupo">
        <label>Período rápido</label>
        <div class="periodos-rapidos">
          <button type="button" [class.ativo]="periodoRapido === 'hoje'" (click)="selecionePeriodoRapido('hoje')">Hoje</button>
          <button type="button" [class.ativo]="periodoRapido === 'ontem'" (click)="selecionePeriodoRapido('ontem')">Ontem</button>
          <button type="button" [class.ativo]="periodoRapido === '7dias'" (click)="selecionePeriodoRapido('7dias')">7 dias</button>
          <button type="button" [class.ativo]="periodoRapido === 'mes'" (click)="selecionePeriodoRapido('mes')">Este mês</button>
          <button type="button" [class.ativo]="periodoRapido === 'personalizado'" (click)="marquePeriodoPersonalizado()">Personalizado</button>
        </div>
      </div>

      <div class="linha-periodo">
        <label>
          <span>Data e horário inicial</span>
          <kendo-datetimepicker [(ngModel)]="filtroRascunho.inicio" (valueChange)="marquePeriodoPersonalizado()"
                                [format]="'dd/MM/yyyy HH:mm'">
            <kendo-datetimepicker-messages
              today="Hoje"
              toggle="Alterar data e horário"
              cancel="Cancelar"
              dateTab="Data"
              timeTab="Hora"
              now="Agora"
              accept="Ok">
            </kendo-datetimepicker-messages>
          </kendo-datetimepicker>
        </label>
        <label>
          <span>Data e horário final</span>
          <kendo-datetimepicker [(ngModel)]="filtroRascunho.fim" (valueChange)="marquePeriodoPersonalizado()"
                                [format]="'dd/MM/yyyy HH:mm'">
            <kendo-datetimepicker-messages
              today="Hoje"
              toggle="Alterar data e horário"
              cancel="Cancelar"
              dateTab="Data"
              timeTab="Hora"
              now="Agora"
              accept="Ok">
            </kendo-datetimepicker-messages>
          </kendo-datetimepicker>
        </label>
        <div class="acoes-filtro">
          <button type="button" class="btn-financeiro btn-limpar" (click)="limpeFiltros()">Limpar</button>
          <button type="button" class="btn-financeiro btn-primario" (click)="apliqueFiltros()"
                  [disabled]="carregando">
            <i *ngIf="carregando" class="k-icon k-i-loading"></i>
            <i *ngIf="!carregando" class="fe-filter"></i>
            {{carregando ? 'Aplicando...' : 'Aplicar filtros'}}
          </button>
        </div>
      </div>
    </div>

    <div class="chips-filtros">
      <div class="grupo-chips">
        <label>Situação do pagamento</label>
        <div>
          <button type="button" [class.ativo]="filtroRascunho.pagos" (click)="filtroRascunho.pagos = !filtroRascunho.pagos"
                  [disabled]="filtroRascunho.baseData === 'pagamento'">Pagos</button>
          <button type="button" [class.ativo]="filtroRascunho.naoPagos" (click)="filtroRascunho.naoPagos = !filtroRascunho.naoPagos"
                  [disabled]="filtroRascunho.baseData === 'pagamento'">Não pagos</button>
        </div>
      </div>
      <div class="grupo-chips">
        <label>Canal da venda</label>
        <div>
          <button type="button" *ngIf="!balcao" [class.ativo]="filtroRascunho.delivery"
                  (click)="filtroRascunho.delivery = !filtroRascunho.delivery">Delivery</button>
          <button type="button" *ngIf="!balcao" [class.ativo]="filtroRascunho.mesa"
                  (click)="filtroRascunho.mesa = !filtroRascunho.mesa">Mesa</button>
          <button type="button" *ngIf="!balcao && !empresa.integracaoDelivery" [class.ativo]="filtroRascunho.balcao"
                  (click)="filtroRascunho.balcao = !filtroRascunho.balcao">Balcão</button>
          <button type="button" *ngIf="balcao" class="ativo" disabled>Balcão</button>
        </div>
      </div>
      <button type="button" class="link-filtro" (click)="filtrosAvancadosAbertos = !filtrosAvancadosAbertos">
        Mais filtros (7)
        <i class="fe-chevron-down" [class.girado]="filtrosAvancadosAbertos"></i>
      </button>
    </div>

    <div class="filtros-avancados" *ngIf="filtrosAvancadosAbertos">
      <label *ngIf="redes.length">
        <span>Rede</span>
        <kendo-combobox [(ngModel)]="filtroRascunho.rede" [data]="redes" textField="nome"
                        placeholder="Todas as redes"></kendo-combobox>
      </label>
      <label>
        <span>Formas de pagamento</span>
        <kendo-multiselect [(ngModel)]="filtroRascunho.formasDePagamento" [data]="empresa.formasDePagamento"
                           textField="descricao" valueField="id" placeholder="Todas"></kendo-multiselect>
      </label>
      <label *ngIf="!balcao">
        <span>Formas de entrega</span>
        <kendo-combobox [(ngModel)]="filtroRascunho.formaDeEntregaEmpresa" [data]="empresa.formasDeEntrega"
                        textField="nome" placeholder="Todas"></kendo-combobox>
      </label>
      <label *ngIf="cupons.length">
        <span>Cupons</span>
        <kendo-multiselect [(ngModel)]="filtroRascunho.cupons" [data]="cupons" textField="codigo"
                           valueField="id" placeholder="Todos"></kendo-multiselect>
      </label>
      <label *ngIf="promocoes.length">
        <span>Promoções</span>
        <kendo-multiselect [(ngModel)]="filtroRascunho.promocoes" [data]="promocoes" textField="descricao"
                           valueField="id" placeholder="Todas"></kendo-multiselect>
      </label>
      <label>
        <span>Origem do pedido</span>
        <kendo-multiselect [(ngModel)]="filtroRascunho.origens" [data]="origensPedido" textField="nome"
                           valueField="valor" [valuePrimitive]="true" placeholder="Todas as origens"></kendo-multiselect>
      </label>
      <label>
        <span>Autoria do pedido</span>
        <kendo-combobox [(ngModel)]="filtroRascunho.autoriaPedido" [data]="autoriasPedido" textField="nome"
                        valueField="valor" [valuePrimitive]="true" [allowCustom]="false" placeholder="Todos"
                        (ngModelChange)="altereAutoriaPedido($event)"></kendo-combobox>
      </label>
      <label *ngIf="operadores.length">
        <span>Operadores</span>
        <kendo-multiselect [(ngModel)]="filtroRascunho.operadores" [data]="operadores" textField="nome"
                           valueField="id" placeholder="Todos"
                           (ngModelChange)="altereOperadoresSelecionados($event)"></kendo-multiselect>
      </label>
      <label *ngIf="garcons.length && filtroRascunho.mesa">
        <span>Garçons</span>
        <kendo-multiselect [(ngModel)]="filtroRascunho.garcons" [data]="garcons" textField="nome"
                           valueField="id" placeholder="Todos"></kendo-multiselect>
      </label>
    </div>
  </section>

  <div class="alerta-relatorio" *ngIf="erroCarregamento">
    <i class="fe-alert-circle"></i> {{erroCarregamento}}
    <button type="button" (click)="carregueResumoVendas(true)">Tentar novamente</button>
  </div>

  <section class="cards-resumo" [class.filtro-pagamento]="filtrandoPorFormaPagamento">
    <article>
      <div class="icone-card azul"><i class="fe-dollar-sign"></i></div>
      <p>{{rotuloTotalFinanceiro}}</p>
      <strong>{{totalFinanceiroExibido | currency:'BRL'}}</strong>
      <small>{{descricaoTotalFinanceiro}}</small>
    </article>
    <article *ngIf="!filtrandoPorFormaPagamento">
      <div class="icone-card roxo"><i class="fe-shopping-bag"></i></div>
      <p>Total de produtos</p>
      <strong>{{resumoVendas.total | currency:'BRL'}}</strong>
      <small>Valor líquido dos produtos</small>
    </article>
    <article *ngIf="!filtrandoPorFormaPagamento">
      <div class="icone-card laranja"><i class="fe-credit-card"></i></div>
      <p>Taxas de pagamento</p>
      <strong>{{resumoVendas.totalTaxaFormaPagamento | currency:'BRL'}}</strong>
      <small>{{percentualTaxaPagamento | number:'1.1-1'}}% do total</small>
    </article>
    <article *ngIf="!filtrandoPorFormaPagamento">
      <div class="icone-card verde"><i class="fe-truck"></i></div>
      <p>Taxas de entrega</p>
      <strong>{{resumoVendas.taxaDeEntrega | currency:'BRL'}}</strong>
      <small>{{percentualTaxaEntrega | number:'1.1-1'}}% do total</small>
    </article>
    <article>
      <div class="icone-card ciano"><i class="fe-hash"></i></div>
      <p>Quantidade de pedidos</p>
      <strong>{{resumoVendas.qtde | number}}</strong>
      <small>Pedidos no período</small>
    </article>
    <article *ngIf="!filtrandoPorFormaPagamento">
      <div class="icone-card amarelo"><i class="fe-trending-up"></i></div>
      <p>Ticket médio</p>
      <strong>{{resumoVendas.ticketMedio | currency:'BRL'}}</strong>
      <small>Média por pedido</small>
    </article>
  </section>

  <div class="status-atualizacao">
    <span *ngIf="carregando"><i class="k-icon k-i-loading"></i> Atualizando relatório...</span>
    <span *ngIf="!carregando && ultimaAtualizacao">Atualizado às {{ultimaAtualizacao | date:'HH:mm'}}</span>
  </div>

  <div class="barra-relatorio">
    <div>
      <h2>Detalhamento financeiro</h2>
      <p>{{rotuloColunaData}} · {{obtenhaDescricaoFiltro()}}</p>
    </div>
    <div class="acoes-relatorio">
      <div class="seletor-visualizacao" *ngIf="abaPrincipalAtiva === 'vendas'">
        <button type="button" [class.ativo]="visualizacaoVendas === 'tabela'" (click)="visualizacaoVendas = 'tabela'">
          <i class="fe-list"></i> Tabela
        </button>
        <button type="button" [class.ativo]="visualizacaoVendas === 'grafico'" (click)="visualizacaoVendas = 'grafico'">
          <i class="fe-bar-chart-2"></i> Gráfico
        </button>
      </div>
      <button type="button" class="btn-financeiro btn-secundario" (click)="exporteCsvAbaAtiva()">
        <i class="fe-download"></i> Exportar CSV
      </button>
    </div>
  </div>
</div>

<div class="financeiro-layout-legado">
  <h4   class="page-title">
  <i class="fe-bar-chart-2"></i>
  Financeiro {{this.balcao ? 'Balcão' : ''}}</h4>

<kendo-panelbar class="mb-0 pb-0" style="    border-bottom: 0;">
  <kendo-panelbar-item [title]="'Filtros'" [expanded]="true"  >
    <ng-template kendoPanelBarContent>
      <div class="card card-body  pt-2 pb-0">
        <div class="row filtro">
          <div class="col-md-auto" *ngIf="!periodoEspecifico">
            <label>
              <span class="label lh">Mês <br></span>
              <kendo-datepicker style="width: 20em"  class="form-control"
                                [bottomView]="'year'"
                                [topView]="'year'"
                                [format]="'MMMM yyyy'"
                                [activeView]="'year'"
                                [max]="hoje"
                                (valueChange)="mudouValorMes($event)"
                                [(value)]="valorMes">
              </kendo-datepicker>

              <p class="text-blue cpointer mt-2" (click)="exibirPeriodoEspecifico()">
                Período especifico</p>
            </label>

          </div>

          <div  class="col-md-auto" *ngIf="periodoEspecifico">
            <kendo-daterange  class="mr-2" >
              <label>
                <span class="label lh">De <br></span>
                <kendo-datetimepicker style="width: 16em"  [(ngModel)]="filtro.inicio"  (ngModelChange)="carregueResumoVendas()">
                  <kendo-datetimepicker-messages
                    today="Hoje"
                    toggle="Alterar data"
                    cancel="Cancelar"
                    dateTab="Data"
                    timeTab="Hora"
                    now="Agora"
                    accept="Ok"
                  ></kendo-datetimepicker-messages>

                </kendo-datetimepicker>
              </label>
              <label class="ml-2 ">
                <span class="label  lh">Até </span><br>
                <kendo-datetimepicker style="width: 16em" [(ngModel)]="filtro.fim" (ngModelChange)="carregueResumoVendas()" >
                  <kendo-datetimepicker-messages
                    today="Hoje"
                    toggle="Alterar data"
                    cancel="Cancelar"
                    dateTab="Data"
                    timeTab="Hora"
                    now="Agora"
                    accept="Ok"
                  ></kendo-datetimepicker-messages>
                </kendo-datetimepicker>

              </label>
              <p class="text-blue cpointer" (click)="exibirPeriodoMensal()">
                Período mensal</p>

            </kendo-daterange>
          </div>

          <div class="col-md-auto">
            <div class="form-group d-inline-block ">
              <div class="mb-4"></div>
              <input type="checkbox" id="pagos" name="pagos" class="k-checkbox " kendoCheckBox  [(ngModel)]="filtro.pagos"  (ngModelChange)="carregueResumoVendas()"/>
              <label class="k-checkbox-label" for="pagos">Pagos</label>
            </div>

            <div class="form-group  d-inline-block ml-2">
              <div class="mb-4"></div>
              <input type="checkbox" id="naoPagos" name="naoPagos" class="k-checkbox "  kendoCheckBox  [(ngModel)]="filtro.naoPagos"  (ngModelChange)="carregueResumoVendas()"/>
              <label class="k-checkbox-label" for="naoPagos">Não pagos</label>
            </div>
            <ng-container *ngIf="!this.balcao">
              <div class="ml-2 form-group d-inline-block " >
                <div class="mb-4"></div>
                <input type="checkbox" id="delivery" name="delivery" class="k-checkbox " kendoCheckBox  [(ngModel)]="filtro.delivery"  (ngModelChange)="carregueResumoVendas()"/>
                <label class="k-checkbox-label" for="delivery">Delivery</label>
              </div>

              <div class="form-group  d-inline-block ml-2"  >
                <div class="mb-4"></div>
                <input type="checkbox" id="mesa" name="mesa" class="k-checkbox " kendoCheckBox   [(ngModel)]="filtro.mesa"  (ngModelChange)="carregueResumoVendas()"/>
                <label class="k-checkbox-label" for="mesa">Mesa</label>
              </div>

              <div class="form-group  d-inline-block ml-2"  *ngIf="!empresa.integracaoDelivery">
                <div class="mb-4"></div>
                <input type="checkbox" id="balcao" name="balcao" class="k-checkbox " kendoCheckBox   [(ngModel)]="filtro.balcao"  (ngModelChange)="carregueResumoVendas()"/>
                <label class="k-checkbox-label" for="balcao">Balcão</label>
              </div>

            </ng-container>


          </div>

        </div>

        <div class="row filtro">
          <div class="col-12 col-sm-3" *ngIf="redes.length">
            <div class="form-group mb-3  "   >
              <label >Rede</label>
              <kendo-combobox  name="rede" [(ngModel)]="filtro.rede" [data]="redes"
                               placeholder="Filtre pela rede" class="form-control" [textField]="'nome'"
                               (ngModelChange)="carregueResumoVendas()">
              </kendo-combobox>


            </div>
          </div>

          <div class="col-12 col-sm-3">
            <div class="form-group mb-3  "   >
              <label for="forma">Formas de pagamento</label>

              <kendo-multiselect id="forma" name="forma" [(ngModel)]="filtro.formasDePagamento" [data]="empresa.formasDePagamento"
                                 placeholder="Filtre pelas formas de pagamento" class="form-control"

                                 textField="descricao" valueField="id"

                                 (ngModelChange)="carregueResumoVendas()">
              </kendo-multiselect>

            </div>
          </div>

          <div class="col-12 col-sm-3">
            <div class="form-group mb-3  "   >
              <label for="forma">Formas de entrega</label>

              <kendo-combobox id="formaEntrega" name="formaEntrega" [(ngModel)]="filtro.formaDeEntregaEmpresa" [data]="empresa.formasDeEntrega"
                              placeholder="Filtre pelas formas de entrega" class="form-control" [textField]="'nome'"
                              (ngModelChange)="carregueResumoVendas()">
              </kendo-combobox>

            </div>
          </div>

          <div class="col-12 col-sm-3" >
            <div class="form-group mb-3  "  *ngIf="cupons.length"  >
              <label for="cupons">Cupons</label>
              <kendo-multiselect id="cupons" name="cupons" [(ngModel)]="filtro.cupons" [data]="cupons"
                                 placeholder="Filtre por cupons" class="form-control"  textField="codigo" valueField="id"
                                 (ngModelChange)="carregueResumoVendas()">
              </kendo-multiselect>

            </div>

          </div>

          <div class="col-12 col-sm-3" >
            <div class="form-group mb-3  "  *ngIf="operadores.length"  >
              <label for="operadores">Operadores</label>
              <kendo-multiselect id="operadores" name="operadores" [(ngModel)]="filtro.operadores" [data]="operadores"
                                 placeholder="Filtre por operadores" class="form-control"  textField="nome" valueField="id"
                                 (ngModelChange)="carregueResumoVendas()">
              </kendo-multiselect>

            </div>

          </div>

          <div class="col-12 col-sm-3"  *ngIf="garcons.length && filtro.mesa">
            <div class="form-group mb-3  "   >
              <label for="garcom">Garçons</label>
              <kendo-multiselect id="garcom" name="garcom" [(ngModel)]="filtro.garcons" [data]="garcons"
                                 placeholder="Filtre por garçom" class="form-control"  textField="nome" valueField="id"
                                 (ngModelChange)="carregueResumoVendas()">
              </kendo-multiselect>

            </div>
          </div>


          <div class="col-12 col-sm-3" >
            <div class="form-group mb-3  "  *ngIf="promocoes.length"  >
              <label for="promocoes">Promoções</label>
              <kendo-multiselect id="promocoes" name="promocoes" [(ngModel)]="filtro.promocoes" [data]="promocoes"
                                 placeholder="Filtre por promocoes" class="form-control"  textField="descricao" valueField="id"
                                 (ngModelChange)="carregueResumoVendas()">
              </kendo-multiselect>

            </div>

          </div>
        </div>
      </div>
    </ng-template>
  </kendo-panelbar-item>
</kendo-panelbar>

<div>
  <h4 class=" ">Resumo
    <button class="button btn btn-sm btn-blue ml-2 " (click)="imprimaRelatorio()">
      <i class="k-icon k-i-printer mr-1"></i> Imprimir </button>
  </h4>

</div>
<div class="clearfix"></div>
<div class="row">
  <div class="col" *ngIf="!resumoVendas.totalPagamentosComTaxa || (resumoVendas.totalComTaxa === resumoVendas.totalPagamentosComTaxa)">
    <div class="card card-body text-xs-center">
      <h4 class="card-title text-muted">      Total de vendas       </h4>
      <h5 class="card-text text-warning">
        {{resumoVendas.totalComTaxa | currency: "BRL"}}

        <i class="k-icon k-i-loading " *ngIf="carregando"></i>
      </h5>
    </div>
  </div>
  <div class="col" *ngIf="resumoVendas.totalPagamentosComTaxa && (resumoVendas.totalComTaxa != resumoVendas.totalPagamentosComTaxa)">
    <div class="card card-body text-xs-center">
      <h4 class="card-title text-muted">      Total pagamentos       </h4>
      <h5 class="card-text text-warning">
        {{resumoVendas.totalPagamentosComTaxa | currency: "BRL"}}

        <i class="k-icon k-i-loading " *ngIf="carregando"></i>
      </h5>
    </div>
  </div>
  <div class="col" *ngIf="!resumoVendas.totalPagamentosComTaxa || (resumoVendas.totalComTaxa === resumoVendas.totalPagamentosComTaxa)">
    <div class="card card-body text-xs-center">
      <h4 class="card-title text-muted">      Taxa de Entrega       </h4>
      <h5 class="card-text text-warning">
        {{resumoVendas.taxaDeEntrega | currency: "BRL"}}
        <i class="k-icon k-i-loading " *ngIf="carregando"></i>
      </h5>
    </div>
  </div>

  <div class="col" *ngIf="!resumoVendas.totalPagamentosComTaxa || (resumoVendas.totalComTaxa === resumoVendas.totalPagamentosComTaxa)">
    <div class="card card-body text-xs-center" >
      <h4 class="card-title text-muted">  Taxa Forma Pagamento    </h4>
      <h5 class="card-text text-warning">
        {{resumoVendas.totalTaxaFormaPagamento | currency: "BRL"}}
        <i class="k-icon k-i-loading " *ngIf="carregando"></i>
      </h5>
    </div>
  </div>

  <div class="col" *ngIf="!resumoVendas.totalPagamentosComTaxa || (resumoVendas.totalComTaxa === resumoVendas.totalPagamentosComTaxa)">
    <div class="card card-body text-xs-center">
      <h4 class="card-title text-muted">      Total Produtos         </h4>
      <h5 class="card-text text-warning">
        {{(resumoVendas.total  ) | currency: "BRL"}}
        <i class="k-icon k-i-loading " *ngIf="carregando"></i>
      </h5>
    </div>
  </div>

  <div class="col">
    <div class="card card-body text-xs-center">
      <h4 class="card-title text-muted"> Qtde. Pedidos   </h4>
      <h5 class="card-text ">
        {{resumoVendas.qtde | number}}  <i class="k-icon k-i-loading " *ngIf="carregando"></i>
      </h5>
    </div>
  </div>

  <div class="col" *ngIf="!resumoVendas.totalPagamentosComTaxa || (resumoVendas.totalComTaxa === resumoVendas.totalPagamentosComTaxa)">
    <div class="card card-body text-xs-center">
      <h4 class="card-title text-muted"> Ticket Médio  </h4>
      <h5 class="card-text">
        {{resumoVendas.ticketMedio | currency: "BRL"}}  <i class="k-icon k-i-loading " *ngIf="carregando"></i>
      </h5>
    </div>
  </div>

</div>

</div>

<div class="card financeiro-conteudo">
  <div class="card-body">
    <div  [hidden]="vendasDoDia || vendasProduto">

      <kendo-tabstrip  #tabVendas class="nav-bordered mt-3" (tabSelect)="selecionouTab($event)">
        <kendo-tabstrip-tab [title]="'Lojas'" [id]="'loja'" *ngIf="rede" [selected]="rede">
          <ng-template kendoTabContent>
            <h5>Vendas por loja <b>{{obtenhaDescricaoFiltro()}}</b></h5>

            <kendo-grid  [style]=""
                         [data]="vendasLojasResultSet"
                         [loading]="carregando" style="min-height: 300px;"
                         [sortable]="{mode: 'single'}"
                         [sort]="sortLoja"
                         (sortChange)="sortChangeLojas($event)">

              <ng-template kendoGridToolbarTemplate>
                <button type="button" kendoGridExcelCommand icon="file-excel">Exportar</button>
              </ng-template>

              <kendo-grid-column title="Cod. Loja"  field="codigoLoja"   [width]="150"  >
                <ng-template kendoGridCellTemplate let-resumo  >
                  <span class="text-dark">{{resumo.codigoLoja}}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Loja"     field="nomeLoja">
                <ng-template kendoGridCellTemplate let-resumo  >
                  <span class="text-dark">{{resumo.nomeLoja}}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Qtde Pedidos"   field="qtde"    [width]="150"  >
                <ng-template kendoGridCellTemplate let-resumo  >
                  <b>{{resumo.qtde | number}}</b>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Total vendido"    field="totalComTaxa"  [width]="250" >
                <ng-template kendoGridCellTemplate let-resumo  >
              <span class="text-success">
                 <b>   {{resumo.totalComTaxa | currency: "BRL"}}</b>
              </span>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Taxa de Entrega">
                <ng-template kendoGridCellTemplate let-resumo  >
              <span class="text-success">
                 <b>   {{resumo.totalTaxaDeEntrega | currency: "BRL"}}</b>
              </span>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Ticket médio"    >
                <ng-template kendoGridCellTemplate let-resumo  >
                  <span class="text-muted"><b>{{resumo.ticketMedio | currency: "BRL"}}</b></span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('lojas')"></kendo-grid-excel>

            </kendo-grid>

            <div class="mt-2 mb-2"></div>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab [title]="'Vendas diárias'" [id]="'vendas'" [selected]="!rede">
          <ng-template kendoTabContent>
            <h5>{{filtro.baseData === 'pagamento' ? 'Vendas quitadas' : 'Vendas diárias'}} {{obtenhaDescricaoFiltro()}}</h5>
            <kendo-grid *ngIf="visualizacaoVendas === 'tabela'"
              [style]=""
              [kendoGridBinding]="resumoVendas.diarias"
              [loading]="carregando" style="min-height: 300px;">

              <kendo-grid-messages
                pagerPage="Página"
                pagerOf="de"
                pagerItems="itens"
                noRecords="nenhuma venda no periódo"
                loading="Carregando"
                pagerItemsPerPage="ítems por página"
              >
              </kendo-grid-messages>
              <ng-template kendoGridToolbarTemplate>
                <div class="float-right">
                  <button type="button" class="btn btn-outline-secondary btn-sm   "
                          kendoGridExcelCommand icon="file-excel">Exportar</button>


                </div>
              </ng-template>
              <kendo-grid-column [title]="rotuloColunaData" field="dia"  [width]="170"  >
                <ng-template kendoGridCellTemplate let-resumoDia  >
                  <span class="text-dark">{{resumoDia.dia}}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Qtde Pedidos" field="qtde" [width]="150"  >
                <ng-template kendoGridCellTemplate let-resumoDia  >
                  <b>{{resumoDia.qtde | number}}</b>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Produtos" field="qtdeLinhas" [width]="120">
                <ng-template kendoGridCellTemplate let-resumoDia>
                  {{resumoDia.qtdeLinhas | number}}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Total vendido"  field="totalComTaxa"   [width]="250"
                                 *ngIf="!filtrandoPorFormaPagamento">
                <ng-template kendoGridCellTemplate let-resumoDia  >
              <span class="text-success">
                 <b>   {{resumoDia.totalComTaxa | currency: "BRL"}}</b>
              </span>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Total pagamentos"  field="totalPagamentosComTaxa"    [width]="250"
                                 *ngIf="filtrandoPorFormaPagamento">
                <ng-template kendoGridCellTemplate let-resumoDia  >
              <span class="text-success">
                 <b>   {{resumoDia.totalPagamentosComTaxa | currency: "BRL"}}</b>
              </span>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Taxa de Entrega" field="totalTaxaDeEntrega"
                                 *ngIf="!filtrandoPorFormaPagamento">
                <ng-template kendoGridCellTemplate let-resumoDia  >
              <span class="text-success">
                 <b>   {{resumoDia.totalTaxaDeEntrega | currency: "BRL"}}</b>
              </span>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Taxa de pagamento" field="totalTaxaFormaPagamento" [width]="180"
                                 *ngIf="!filtrandoPorFormaPagamento">
                <ng-template kendoGridCellTemplate let-resumoDia>
                  {{resumoDia.totalTaxaFormaPagamento | currency:'BRL'}}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Valor Líquido" field="total"
                                 *ngIf="!filtrandoPorFormaPagamento">
                <ng-template kendoGridCellTemplate let-resumoDia  >
              <span class="text-success">
                 <b>   {{(resumoDia.total ) | currency: "BRL"}}</b>
              </span>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Ticket médio"     field="ticketMedio"
                                 *ngIf="!filtrandoPorFormaPagamento">
                <ng-template kendoGridCellTemplate let-resumoDia  >
                  <span class="text-muted"><b>{{resumoDia.ticketMedio | currency: "BRL"}}</b></span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column      >

                <ng-template kendoGridCellTemplate let-resumoDia  >
                  <button class="btn btn-outline-blue btn-sm ml-1 " (click)="verPedidos(resumoDia)"  title="ver pedidos" kendoTooltip>
                    <i class="fe-list fa-lg"></i>
                  </button>
                </ng-template>

              </kendo-grid-column>

              <kendo-grid-column title="Status" [width]="120">
                <ng-template kendoGridCellTemplate>
                  <span class="status-quitado">{{filtro.baseData === 'pagamento' ? 'Quitado' : (filtro.pagos && !filtro.naoPagos ? 'Pago' : 'Misto')}}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-diarias')"></kendo-grid-excel>

            </kendo-grid>

            <div class="grafico-vendas" *ngIf="visualizacaoVendas === 'grafico'">
              <kendo-chart>
                <kendo-chart-title [text]="filtro.baseData === 'pagamento' ? 'Vendas por data da quitação' : 'Vendas por data da venda/entrega'"></kendo-chart-title>
                <kendo-chart-tooltip format="{0:c2}"></kendo-chart-tooltip>
                <kendo-chart-series>
                  <kendo-chart-series-item type="column" [data]="resumoVendas.diarias" [field]="campoTotalFinanceiroDiario" categoryField="dia"
                                           color="#2563eb"></kendo-chart-series-item>
                </kendo-chart-series>
              </kendo-chart>
            </div>

            <div class="mt-2 mb-2"></div>
          </ng-template>

        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab [title]="'Produtos'" [id]="'produtos'"  >
          <ng-template kendoTabContent>
            <h5  >Produtos vendidos {{obtenhaDescricaoFiltro()}}

              <div class="ml-2 form-group d-inline-block ">

                <input type="checkbox" id="porAdicionais" name="porAdicionais" class="k-checkbox " kendoCheckBox  [(ngModel)]="filtro.porAdicionais"
                       (ngModelChange)="carregueResumoProdutos()"/>
                <label class="k-checkbox-label" for="porAdicionais">Exibir vendas dos adicionais</label>
              </div>

            </h5>

            <kendo-grid
              [style]=""
              [kendoGridBinding]="resumoProdutos.produtos"
              [loading]="resumoProdutos.carregando"
              [groupable]="true"  [group]="group"   >

              <kendo-grid-messages
                pagerPage="Página"
                pagerOf="de"
                pagerItems="itens"
                noRecords="nenhuma produto vendido no periódo"
                loading="Carregando"
                pagerItemsPerPage="ítems por página"
              >
              </kendo-grid-messages>
              <ng-template kendoGridToolbarTemplate>
                <div class="float-right">
                  <button type="button" class="btn btn-outline-secondary btn-sm   "
                          kendoGridExcelCommand icon="file-excel">Exportar</button>


                  <button class="btn btn-outline-secondary btn-sm  ml-1 " *ngIf="!filtro.porAdicionais" kendoTooltip title="exportar produtos/contatos csv"
                          (click)="downloadCsvProdutos()"  >
                    <i class="fa fa-download fa-lg"></i> Exportar vendas/contato
                  </button>
                </div>
              </ng-template>
              <kendo-grid-column title="Codigo" field="codigo"      [width]="100">
                <ng-template kendoGridCellTemplate let-resumoProduto  >
                  <span class="text-blue"><b>{{resumoProduto.codigo}}</b></span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Produto"    field="nome" >
                <ng-template kendoGridCellTemplate let-resumoProduto  >
                  <span class="text-dark">{{resumoProduto.nome}}</span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Qtde vendido"    field="qtdeDescricao"  [width]="250" >
                <ng-template kendoGridCellTemplate let-resumoProduto  >
              <span >
                 <b>   {{resumoProduto.qtdeDescricao  }}</b>
              </span>


                </ng-template>
                <ng-template kendoGridGroupFooterTemplate let-aggregates="aggregates">
                  <span> Qtde vendido: {{ aggregates.qtde.sum | number }} </span>
                </ng-template>

              </kendo-grid-column>

              <kendo-grid-column title="Total vendido"   field="total" [width]="250"  >
                <ng-template kendoGridCellTemplate let-resumoProduto  >
                <span class="text-success">
                   <b>{{resumoProduto.total | currency: "BRL"}}</b>
                </span>

                </ng-template>

                <ng-template kendoGridGroupFooterTemplate let-aggregates="aggregates" >
                  <ng-container *ngIf="resumoProdutos.totalDescontos ">
                    <label> Total produtos: <span class="text-success"> +{{ aggregates.total.sum  | currency: 'BRL'}}</span> </label>
                    <label> Total descontos: <span class="text-danger"> -{{ resumoProdutos.totalDescontos  | currency: 'BRL'}}</span></label>
                  </ng-container>
                  <label> Total:  <span class="text-success">

                  <b>{{ (aggregates.total.sum - resumoProdutos.totalDescontos)   | currency: 'BRL'}}</b> </span> </label>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column    *ngIf="!filtro.porAdicionais"  >

                <ng-template kendoGridCellTemplate let-resumoProduto  >
                  <button class="btn btn-outline-blue btn-sm ml-1 " (click)="verDetalhesVendasProduto(resumoProduto)"  title="ver detalhes" kendoTooltip>
                    <i class="fe-list fa-lg"></i>
                  </button>
                </ng-template>

              </kendo-grid-column>

              <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload(filtro.porAdicionais?  'vendas-adicionais' : 'vendas-produtos')"></kendo-grid-excel>

            </kendo-grid>

            <div class="mt-2 mb-2"></div>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab [title]="'Combinações que Vendem'" [id]="'vendemJuntos'">
          <ng-template kendoTabContent>
            <div class="vendem-juntos-cabecalho">
              <div>
                <h5>Combinações que Vendem {{obtenhaDescricaoFiltro()}}</h5>
                <p>Produtos que seus clientes já pedem juntos — vire combo e aumente o ticket</p>
              </div>
            </div>

            <ng-container *ngIf="!parVendemJuntosSelecionado">
              <div class="vendem-juntos-filtros">
                <label>
                  <span>Produto âncora</span>
                  <kendo-combobox [(ngModel)]="produtoBaseVendemJuntos"
                                  [data]="produtosBaseVendemJuntos"
                                  textField="nome"
                                  placeholder="Todos os produtos">
                  </kendo-combobox>
                </label>
                <label>
                  <span>Mínimo de pedidos juntos</span>
                  <kendo-numerictextbox [(ngModel)]="minimoPedidosJuntos" [min]="1" [max]="1000"
                                        [format]="'n0'">
                  </kendo-numerictextbox>
                </label>
                <button type="button" class="btn-financeiro btn-primario"
                        (click)="carregueResumoProdutosQueVendemJuntos(true)"
                        [disabled]="resumoProdutosQueVendemJuntos.carregando">
                  Aplicar filtros
                </button>
              </div>

              <section class="vendem-juntos-visao-produto" *ngIf="resumoProdutoBaseVendemJuntos as resumoProduto">
                <span>Visão por produto</span>
                <h5>O que vende junto com {{resumoProduto.produtoBase}}?</h5>
                <p>{{resumoProduto.produtoBase}} apareceu em <b>{{resumoProduto.pedidosProdutoBase | number}}</b> pedidos no período.</p>
              </section>

              <div class="vendem-juntos-resumo" *ngIf="!produtoBaseVendemJuntos">
                <article>
                  <span>Pedidos analisados</span>
                  <strong>{{resumoProdutosQueVendemJuntos.pedidosAnalisados | number}}</strong>
                </article>
                <article>
                  <span>Combinações únicas</span>
                  <strong>{{totalCombinacoesUnicasVendemJuntos | number}}</strong>
                </article>
                <article class="oportunidade">
                  <span>Melhor oportunidade de cross-sell</span>
                  <strong *ngIf="principalOportunidadeVendemJuntos as oportunidade">
                    {{oportunidade.produtoBase}} <i class="fe-arrow-right"></i> {{oportunidade.produtoJunto}}
                  </strong>
                  <strong *ngIf="!principalOportunidadeVendemJuntos">Nenhuma combinação atingiu o mínimo</strong>
                  <small *ngIf="principalOportunidadeVendemJuntos as oportunidade">
                    {{oportunidade.taxaJunto | number:'1.1-1'}}% de adesão histórica
                  </small>
                </article>
              </div>

              <div class="vendem-juntos-conceito">
                <i class="fe-info"></i>
                <div>
                  <strong>Leia da esquerda para a direita</strong>
                  <span>A recomendação começa pelo produto com mais pedidos no período. A adesão histórica mostra quantos desses pedidos também continham a sugestão.</span>
                </div>
              </div>

              <div class="vendem-juntos-barra">
                <label class="vendem-juntos-busca">
                  <span>Buscar produto</span>
                  <div>
                    <input type="search" class="form-control" [(ngModel)]="buscaProdutoVendemJuntosRascunho"
                           placeholder="Nome do produto" (keyup.enter)="apliqueBuscaVendemJuntos()">
                    <button type="button" class="btn btn-outline-secondary" (click)="apliqueBuscaVendemJuntos()">Buscar</button>
                  </div>
                </label>
                <label class="vendem-juntos-ordenacao">
                  <span>Ordenar por</span>
                  <select class="form-control" [(ngModel)]="ordenacaoVendemJuntos">
                    <option *ngFor="let ordenacao of ordenacoesVendemJuntos" [value]="ordenacao.valor">{{ordenacao.nome}}</option>
                  </select>
                </label>
                <button type="button" class="btn btn-outline-secondary vendem-juntos-exportar"
                        (click)="exporteCsvAbaAtiva()">
                  <i class="fe-download"></i> Exportar CSV
                </button>
              </div>

              <div class="vendem-juntos-ajuda">
                <span><b>Pedidos:</b> pedidos distintos que continham os dois produtos.</span>
                <span><b>Adesão histórica:</b> percentual dos pedidos do produto âncora que também continham a sugestão.</span>
                <span><b>Força:</b> acima de 1,00x indica que a combinação ocorre mais que o esperado.</span>
                <span><b>Importante:</b> os dados mostram o que aconteceu no período e não garantem resultados futuros.</span>
              </div>

              <div class="alert alert-danger" *ngIf="erroProdutosQueVendemJuntos">
                {{erroProdutosQueVendemJuntos}}
                <button type="button" class="btn btn-sm btn-outline-danger ml-2"
                        (click)="carregueResumoProdutosQueVendemJuntos(true)">Tentar novamente</button>
              </div>

              <kendo-grid [kendoGridBinding]="paresVendemJuntosExibidos"
                          [loading]="resumoProdutosQueVendemJuntos.carregando"
                          [pageable]="true" [pageSize]="20"
                          style="min-height: 300px">
                <kendo-grid-messages
                  pagerPage="Página"
                  pagerOf="de"
                  pagerItems="itens"
                  [noRecords]="'Nenhuma combinação apareceu em pelo menos ' + minimoPedidosJuntos + ' pedidos neste período. Aumente o período ou reduza o mínimo.'"
                  loading="Descobrindo quais produtos vendem juntos..."
                  pagerItemsPerPage="itens por página">
                </kendo-grid-messages>

                <kendo-grid-column title="Produto âncora" field="produtoBase" [width]="220">
                  <ng-template kendoGridCellTemplate let-par>
                    <b>{{par.produtoBase}}</b>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="" [width]="54" class="vendem-juntos-seta-coluna">
                  <ng-template kendoGridCellTemplate><i class="fe-arrow-right vendem-juntos-seta"></i></ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Sugestão de cross-sell" field="produtoJunto" [width]="270">
                  <ng-template kendoGridCellTemplate let-par>
                    <b class="vendem-juntos-produto-sugerido">{{par.produtoJunto}}</b>
                    <button *ngIf="par.direcaoInversa" type="button" class="vendem-juntos-inversa-toggle"
                            (click)="alterneDirecaoInversaVendemJuntos(par)">
                      <i [class.fe-chevron-down]="direcaoInversaVendemJuntosAberta !== par.chaveCombinacao"
                         [class.fe-chevron-up]="direcaoInversaVendemJuntosAberta === par.chaveCombinacao"></i>
                      Comparar direção inversa
                    </button>
                    <div class="vendem-juntos-inversa"
                         *ngIf="par.direcaoInversa && direcaoInversaVendemJuntosAberta === par.chaveCombinacao">
                      {{par.direcaoInversa.produtoBase}} <i class="fe-arrow-right"></i>
                      {{par.direcaoInversa.produtoJunto}}:
                      <b>{{par.direcaoInversa.taxaJunto | number:'1.1-1'}}%</b>
                    </div>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Pedidos juntos" field="pedidosJuntos" [width]="130">
                  <ng-template kendoGridCellTemplate let-par><b>{{par.pedidosJuntos | number}}</b></ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Adesão histórica" field="taxaJunto" [width]="150">
                  <ng-template kendoGridCellTemplate let-par>{{par.taxaJunto | number:'1.1-1'}}%</ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Força" field="forca" [width]="110">
                  <ng-template kendoGridCellTemplate let-par>
                    <span class="badge" [class.badge-success]="par.forca > 1" [class.badge-secondary]="par.forca <= 1">
                      {{par.forca | number:'1.2-2'}}x
                    </span>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Ação" [width]="155">
                  <ng-template kendoGridCellTemplate let-par>
                    <div class="vendem-juntos-acoes">
                      <button type="button" class="btn btn-primary btn-sm"
                              (click)="vireComboVendemJuntos(par)">
                        <i class="fe-plus"></i> Virar Combo
                      </button>
                      <button type="button" class="btn btn-link btn-sm"
                              (click)="selecioneParVendemJuntos(par)">Ver análise</button>
                    </div>
                  </ng-template>
                </kendo-grid-column>
              </kendo-grid>
            </ng-container>

            <section class="vendem-juntos-detalhe" *ngIf="parVendemJuntosSelecionado as par">
              <header>
                <button type="button" class="btn btn-link" (click)="volteParaListaVendemJuntos()">
                  <i class="fe-arrow-left"></i> Voltar
                </button>
                <div>
                  <span>Estratégia de cross-sell</span>
                  <h4>{{par.produtoBase}} <i class="fe-arrow-right"></i> {{par.produtoJunto}}</h4>
                </div>
              </header>

              <div class="vendem-juntos-metricas">
                <div>
                  <span>{{par.produtoBase}} apareceu em</span>
                  <strong>{{par.pedidosProdutoBase | number}} {{par.pedidosProdutoBase === 1 ? 'pedido' : 'pedidos'}}</strong>
                </div>
                <div>
                  <span>Os dois apareceram juntos em</span>
                  <strong>{{par.pedidosJuntos | number}} {{par.pedidosJuntos === 1 ? 'pedido' : 'pedidos'}}</strong>
                </div>
                <div><span>Adesão histórica (confiança)</span><strong>{{par.taxaJunto | number:'1.1-1'}}%</strong></div>
                <div><span>Frequência geral de {{par.produtoJunto}}</span><strong>{{par.frequenciaGeral | number:'1.1-1'}}%</strong></div>
                <div><span>Força da associação</span><strong>{{par.forca | number:'1.2-2'}}x</strong></div>
              </div>

              <p class="vendem-juntos-insight">
                Quando o cliente escolheu <b>{{par.produtoBase}}</b>, em
                <strong>{{par.taxaJunto | number:'1.1-1'}}%</strong> dos pedidos ele também levou <b>{{par.produtoJunto}}</b>.
                <small>Essa taxa descreve os pedidos do período; não é garantia de conversão futura.</small>
              </p>

              <div class="vendem-juntos-inversa-detalhe" *ngIf="par.direcaoInversa as inversa">
                <span>Na direção inversa</span>
                <b>{{inversa.produtoBase}} <i class="fe-arrow-right"></i> {{inversa.produtoJunto}}</b>
                teve <strong>{{inversa.taxaJunto | number:'1.1-1'}}%</strong> de adesão histórica.
              </div>

              <div class="vendem-juntos-evolucao">
                <h5>Evolução por semana</h5>
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                    <tr>
                      <th>Semana</th>
                      <th>Pedidos com {{par.produtoBase}}</th>
                      <th>Com {{par.produtoJunto}}</th>
                      <th>Adesão histórica</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let semana of par.evolucao">
                      <td>{{semana.semanaInicio | date:'dd/MM'}} a {{semana.semanaFim | date:'dd/MM'}}</td>
                      <td>{{semana.pedidosProdutoBase | number}}</td>
                      <td>{{semana.pedidosJuntos | number}}</td>
                      <td><b>{{semana.taxaJunto | number:'1.1-1'}}%</b></td>
                    </tr>
                    <tr *ngIf="!par.evolucao || !par.evolucao.length">
                      <td colspan="4">Não há evolução semanal disponível para esta combinação.</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="vendem-juntos-pedidos" *ngIf="exibindoPedidosParVendemJuntos">
                <h5>Pedidos que formam este resultado</h5>
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead><tr><th>Pedido</th><th>Data</th><th></th></tr></thead>
                    <tbody>
                    <tr *ngFor="let pedido of pedidosParVendemJuntos">
                      <td><b>#{{pedido.codigo || pedido.id}}</b></td>
                      <td>{{pedido.dataReferencia | date:'dd/MM/yyyy HH:mm'}}</td>
                      <td class="text-right">
                        <a class="btn btn-sm btn-outline-blue"
                           [routerLink]="rede ? ['/admin-grupo/pedidos/detalhes', pedido.empresaId, pedido.guid] : ['/admin/pedidos/detalhes', pedido.guid]">
                          Abrir pedido
                        </a>
                      </td>
                    </tr>
                    <tr *ngIf="!pedidosParVendemJuntos.length">
                      <td colspan="3">Nenhum pedido encontrado para esta combinação.</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <footer>
                <button type="button" class="btn btn-outline-blue" (click)="carreguePedidosParVendemJuntos()"
                        [disabled]="carregandoPedidosParVendemJuntos">
                  <i class="fe-list"></i>
                  {{carregandoPedidosParVendemJuntos ? 'Carregando pedidos...' :
                    (exibindoPedidosParVendemJuntos ? 'Ocultar pedidos' : 'Ver pedidos que formam este resultado')}}
                </button>
                <button type="button" class="btn btn-outline-secondary" (click)="exporteCsvAbaAtiva()">
                  <i class="fe-download"></i> Exportar CSV
                </button>
              </footer>
            </section>

            <div class="mt-2 mb-2"></div>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab [title]="'Combinações'" [id]="'combinacoesProdutos'" >
          <ng-template kendoTabContent>
            <h5>
              Combinações de adicionais {{obtenhaDescricaoFiltro()}}
            </h5>

            <div class="mb-2">
              <span class="mr-3"><b>Qtde total:</b> {{resumoCombinacoes.qtdeTotal | number}}</span>
              <span><b>Total adicionais:</b> {{resumoCombinacoes.totalAdicionais | currency: "BRL"}}</span>
            </div>

            <kendo-grid
              [style]=""
              [kendoGridBinding]="resumoCombinacoes.combinacoes"
              [loading]="resumoCombinacoes.carregando"
              style="min-height: 300">

              <kendo-grid-messages
                pagerPage="Página"
                pagerOf="de"
                pagerItems="itens"
                noRecords="nenhuma combinação no periódo"
                loading="Carregando"
                pagerItemsPerPage="ítems por página"
              >
              </kendo-grid-messages>

              <ng-template kendoGridToolbarTemplate>
                <div class="float-right">
                  <button type="button" class="btn btn-outline-secondary btn-sm"
                          kendoGridExcelCommand icon="file-excel">Exportar</button>
                </div>
              </ng-template>

              <kendo-grid-column title="Produto" field="produto" [width]="250">
                <ng-template kendoGridCellTemplate let-combinacao>
                  <span class="text-dark">{{combinacao.produto}}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Descrição" field="descricaoCombinacao">
                <ng-template kendoGridCellTemplate let-combinacao>
                  <span class="text-dark">{{combinacao.descricaoCombinacao}}</span>
                  <span class="badge badge-secondary ml-2" *ngIf="combinacao.semAdicionais">Sem adicionais</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Qtde" field="qtde" [width]="150">
                <ng-template kendoGridCellTemplate let-combinacao>
                  <b>{{combinacao.qtde | number}}</b>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Total" field="totalAdicionais" [width]="250">
                <ng-template kendoGridCellTemplate let-combinacao>
                  <span class="text-success"><b>{{combinacao.totalAdicionais | currency: "BRL"}}</b></span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-excel [fileName]="obtenhaNomeArquivoCombinacoesGeral()"></kendo-grid-excel>
            </kendo-grid>

            <div class="mt-2 mb-2"></div>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab [title]="'Cupons'" [id]="'cupons'"  >
          <ng-template kendoTabContent>
            <h5 class="float-left">Cupons utilizados {{obtenhaDescricaoFiltro()}}</h5>

            <div class="clearfix"></div>

            <kendo-grid
              [style]=""
              [data]="vendasCuponsResultSet"
              [loading]="resumoCupons.carregando"
              [sortable]="{  allowUnsort: false,  mode:'single'  }"
              [sort]="sortCupom"
              (sortChange)="sortChange($event)"
            >
              <kendo-grid-messages
                pagerPage="Página"
                pagerOf="de"
                pagerItems="itens"
                noRecords="nenhuma venda no periódo"
                loading="Carregando"
                pagerItemsPerPage="ítems por página"
              >
              </kendo-grid-messages>
              <ng-template kendoGridToolbarTemplate>
                <div class="float-right">

                  <button type="button" class="btn btn-outline-secondary btn-sm  ml-1"
                          kendoGridExcelCommand icon="file-excel">Exportar</button>


                  <button class="btn btn-outline-secondary btn-sm  ml-1"  *ngIf="rede"
                          kendoTooltip title="exportar cupons/loja"  (click)="downloadCsvCupons()"  >
                    <i class="fa fa-download fa-lg mr-1"></i> Exportar por lojas
                  </button>


                  <button class="btn  btn-outline-secondary btn-sm   ml-1"
                          kendoTooltip title="exportar cupons/contatos"  (click)="downloadCsvCuponsContatos()"  >
                    <i class="fa fa-download fa-lg mr-1"></i>  Exportar por contatos
                  </button>
                </div>


              </ng-template>

              <kendo-grid-column title="Cupom"  field="codigo"    >
                <ng-template kendoGridCellTemplate let-resumo   >
                  <span class="text-blue"><b>{{resumo.codigo}}</b></span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Qtde vendido"  field="qtde"    [width]="250" >
                <ng-template kendoGridCellTemplate let-resumo  >
                  <span >
                     <b>   {{resumo.qtde  }}</b>
                  </span>

                </ng-template>

                <ng-template   kendoGridFooterTemplate       >
                  <ng-container *ngIf="this.resumoVendas.cupons.length">
                    {{ totalCupons['qtde'].sum }}
                  </ng-container>

                </ng-template>

              </kendo-grid-column>

              <kendo-grid-column title="Total vendido"  [width]="150" field="total"   >
                <ng-template kendoGridCellTemplate let-resumo  >
                <span class="text-success">
                   <b>{{resumo.total | currency: "BRL"}}</b>
                </span>

                </ng-template>
                <ng-template   kendoGridFooterTemplate       >
                  <ng-container *ngIf="this.resumoVendas.cupons.length">
                    {{ totalCupons['total'].sum | currency: "BRL"}}
                  </ng-container>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Total descontos"  [width]="150" field="totalDesconto"   >
                <ng-template kendoGridCellTemplate let-resumo  >
                <span class="text-success">
                   <b>{{resumo.totalDesconto | currency: "BRL"}}</b>
                </span>

                </ng-template>
                <ng-template   kendoGridFooterTemplate       >
                  <ng-container *ngIf="this.resumoVendas.cupons.length">
                    {{ totalCupons['totalDesconto'].sum  | currency: "BRL"}}
                  </ng-container>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column      >

                <ng-template kendoGridCellTemplate let-resumo  >
                  <!-- <button class="btn btn-outline-blue btn-sm ml-1 " (click)="verDetalhesVendasProduto(resumo)"  title="ver detalhes" kendoTooltip>
                    <i class="fe-list fa-lg"></i>
                  </button> -->
                </ng-template>

              </kendo-grid-column>

              <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-cupons')"></kendo-grid-excel>
            </kendo-grid>


            <div class="mt-2 mb-2"></div>


          </ng-template>

        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab [title]="'Promoções'" [id]="'promocoes'"  >
          <ng-template kendoTabContent>
            <h5 class="float-left">Promoções utilizando {{obtenhaDescricaoFiltro()}}</h5>

            <div class="clearfix"></div>

            <kendo-grid
              [style]=""
              [data]="vendasPromocoesResultSet"
              [loading]="resumoPromocoes.carregando"
              [sortable]="{  allowUnsort: false,  mode:'single'  }"
              [sort]="sortCupom"
              (sortChange)="sortChange($event)"
            >
              <kendo-grid-messages
                pagerPage="Página"
                pagerOf="de"
                pagerItems="itens"
                noRecords="nenhuma venda no periódo"
                loading="Carregando"
                pagerItemsPerPage="ítems por página"
              >
              </kendo-grid-messages>
              <ng-template kendoGridToolbarTemplate>
                <div class="float-right">

                  <button type="button" class="btn btn-outline-secondary btn-sm  ml-1"
                          kendoGridExcelCommand icon="file-excel">Exportar</button>


                  <button class="btn btn-outline-secondary btn-sm  ml-1"  *ngIf="rede"
                          kendoTooltip title="exportar promoções/loja"  (click)="downloadCsvPromocoes()"  >
                    <i class="fa fa-download fa-lg mr-1"></i> Exportar por lojas
                  </button>


                  <button class="btn  btn-outline-secondary btn-sm   ml-1"
                          kendoTooltip title="exportar promoções/contatos"  (click)="downloadCsvPromocoesContatos()"  >
                    <i class="fa fa-download fa-lg mr-1"></i>  Exportar por contatos
                  </button>
                </div>


              </ng-template>

              <kendo-grid-column title="Promocao"  field="descricao"    >
                <ng-template kendoGridCellTemplate let-resumo   >
                  <span class="text-blue"><b>{{resumo.descricao}}</b></span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Qtde vendido"  field="qtde"    [width]="250" >
                <ng-template kendoGridCellTemplate let-resumo  >
                  <span >
                     <b>   {{resumo.qtde  }}</b>
                  </span>

                </ng-template>

                <ng-template   kendoGridFooterTemplate       >
                  <ng-container *ngIf="this.resumoVendas.promocoes.length">
                    {{ totalPromocoes['qtde'].sum }}
                  </ng-container>

                </ng-template>

              </kendo-grid-column>

              <kendo-grid-column title="Total vendido"  [width]="150" field="total"   >
                <ng-template kendoGridCellTemplate let-resumo  >
                <span class="text-success">
                   <b>{{resumo.total | currency: "BRL"}}</b>
                </span>

                </ng-template>
                <ng-template   kendoGridFooterTemplate       >
                  <ng-container *ngIf="this.resumoVendas.promocoes.length">
                    {{ totalPromocoes['total'].sum | currency: "BRL"}}
                  </ng-container>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Total descontos"  [width]="150" field="totalDesconto"   >
                <ng-template kendoGridCellTemplate let-resumo  >
                <span class="text-success">
                   <b>{{resumo.totalDesconto | currency: "BRL"}}</b>
                </span>

                </ng-template>
                <ng-template   kendoGridFooterTemplate       >
                  <ng-container *ngIf="this.resumoVendas.promocoes.length">
                    {{ totalPromocoes['totalDesconto'].sum  | currency: "BRL"}}
                  </ng-container>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column      >

                <ng-template kendoGridCellTemplate let-resumo  >
                  <!-- <button class="btn btn-outline-blue btn-sm ml-1 " (click)="verDetalhesVendasProduto(resumo)"  title="ver detalhes" kendoTooltip>
                    <i class="fe-list fa-lg"></i>
                  </button> -->
                </ng-template>

              </kendo-grid-column>

              <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-promocoes')"></kendo-grid-excel>
            </kendo-grid>


            <div class="mt-2 mb-2"></div>


          </ng-template>

        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab [title]="'Pagamentos'" [id]="'formas'"  >
          <ng-template kendoTabContent>
            <h5  >Formas de pagamento  <b>{{obtenhaDescricaoFiltro()}}</b></h5>

            <kendo-grid
              [style]=""
              [kendoGridBinding]="resumoPorFormasPagamento"
              [loading]="carregandoResumoFormaPagamento"  >

              <kendo-grid-messages
                pagerPage="Página"
                pagerOf="de"
                pagerItems="itens"
                noRecords="nenhuma venda no periódo"
                loading="Carregando"
                pagerItemsPerPage="ítems por página"
              >
              </kendo-grid-messages>
              <ng-template kendoGridToolbarTemplate>
                <div class="float-right">
                  <button type="button" class="btn btn-outline-secondary btn-sm   "
                          kendoGridExcelCommand icon="file-excel">Exportar</button>



                </div>
              </ng-template>
              <kendo-grid-column title="Forma"  field="nome"     >
                <ng-template kendoGridCellTemplate let-resumo   >
                  <span class="text-blue"><b>{{resumo.nome}}</b></span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Qtde vendido"  field="qtde"     [width]="250" >
                <ng-template kendoGridCellTemplate let-resumo   >
          <span >
             <b>   {{resumo.qtde  }}</b>
          </span>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Total vendido"  [width]="150" field="total"    >
                <ng-template kendoGridCellTemplate let-resumo  >
            <span class="text-success">
               <b>{{resumo.total | currency: "BRL"}}</b>
            </span>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column      >

                <ng-template kendoGridCellTemplate let-resumoProduto  >
                  <!-- <button class="btn btn-outline-blue btn-sm ml-1 " (click)="verDetalhesVendasProduto(resumoProduto)"  title="ver detalhes" kendoTooltip>
                     <i class="fe-list fa-lg"></i>
                   </button> -->
                </ng-template>

              </kendo-grid-column>

              <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-formas-pagamento')"></kendo-grid-excel>

            </kendo-grid>

          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab [title]="'Entregas'" [id]="'formasEntrega'"  *ngIf="!balcao" >

          <ng-template kendoTabContent>
            <h5  >Formas de entrega  <b>{{obtenhaDescricaoFiltro()}}</b></h5>

            <kendo-grid
              [style]=""
              [data]="resumoVendas.formasDeEntrega"
              [loading]="carregando"  >

              <kendo-grid-messages
                pagerPage="Página"
                pagerOf="de"
                pagerItems="itens"
                noRecords="nenhuma venda no periódo"
                loading="Carregando"
                pagerItemsPerPage="ítems por página"
              >
              </kendo-grid-messages>
              <ng-template kendoGridToolbarTemplate>
                <div class="float-right">
                  <button type="button" class="btn btn-outline-secondary btn-sm   "
                          kendoGridExcelCommand icon="file-excel">Exportar</button>



                </div>
              </ng-template>
              <kendo-grid-column title="Forma"  field="nome"     >
                <ng-template kendoGridCellTemplate let-resumo   >
                  <span class="text-blue"><b>{{resumo.nome}}</b></span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Qtde vendido"  field="qtde"     [width]="250" >
                <ng-template kendoGridCellTemplate let-resumo   >
          <span >
             <b>   {{resumo.qtde  }}</b>
          </span>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Total vendido"  [width]="150" field="total"    >
                <ng-template kendoGridCellTemplate let-resumo  >
            <span class="text-success">
               <b>{{resumo.total | currency: "BRL"}}</b>
            </span>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column      >

                <ng-template kendoGridCellTemplate let-resumoProduto  >
                  <!-- <button class="btn btn-outline-blue btn-sm ml-1 " (click)="verDetalhesVendasProduto(resumoProduto)"  title="ver detalhes" kendoTooltip>
                     <i class="fe-list fa-lg"></i>
                   </button> -->
                </ng-template>

              </kendo-grid-column>

              <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-formas-entrega')"></kendo-grid-excel>

            </kendo-grid>
          </ng-template>

        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab [title]="'Garçons'" [id]="'garcons'"  *ngIf="filtro.mesa">
          <ng-template kendoTabContent>
            <h5>Vendas por garçom <b>{{obtenhaDescricaoFiltro()}}</b></h5>

            <kendo-grid
              [kendoGridBinding]="resumoGarcons.garcons"
              [loading]="resumoGarcons.carregando"
              style="min-height: 300px;">

              <kendo-grid-messages
                pagerPage="Página"
                pagerOf="de"
                pagerItems="itens"
                noRecords="nenhuma venda no periódo"
                loading="Carregando"
                pagerItemsPerPage="ítems por página"
              >
              </kendo-grid-messages>

              <ng-template kendoGridToolbarTemplate>
                <div class="float-right">
                  <button type="button" class="btn btn-outline-secondary btn-sm"
                          kendoGridExcelCommand icon="file-excel">Exportar</button>
                </div>
              </ng-template>

              <kendo-grid-column title="Garçom" field="garcom">
                <ng-template kendoGridCellTemplate let-resumo>
                  <span class="text-dark"><b>{{resumo.garcom}}</b></span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Qtde Pedidos" field="qtde" [width]="150">
                <ng-template kendoGridCellTemplate let-resumo>
                  <b>{{resumo.qtde | number}}</b>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Total vendido" field="total" [width]="250">
                <ng-template kendoGridCellTemplate let-resumo>
                  <span class="text-success">
                    <b>{{resumo.total | currency: "BRL"}}</b>
                  </span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-garcons')"></kendo-grid-excel>
            </kendo-grid>

            <div class="mt-2 mb-2"></div>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab [title]="'Operadores'" [id]="'operadores'">
          <ng-template kendoTabContent>
            <h5>Vendas por operador <b>{{obtenhaDescricaoFiltro()}}</b></h5>

            <kendo-grid
              [kendoGridBinding]="resumoOperadores.operadores"
              [loading]="resumoOperadores.carregando"
              style="min-height: 300px;">

              <kendo-grid-messages
                pagerPage="Página"
                pagerOf="de"
                pagerItems="itens"
                noRecords="nenhuma venda no periódo"
                loading="Carregando"
                pagerItemsPerPage="ítems por página"
              >
              </kendo-grid-messages>

              <ng-template kendoGridToolbarTemplate>
                <div class="float-right">
                  <button type="button" class="btn btn-outline-secondary btn-sm"
                          kendoGridExcelCommand icon="file-excel">Exportar</button>
                </div>
              </ng-template>

              <kendo-grid-column title="Operador" field="operador">
                <ng-template kendoGridCellTemplate let-resumo>
                  <span class="text-dark"><b>{{resumo.operador}}</b></span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Qtde Pedidos" field="qtde" [width]="150">
                <ng-template kendoGridCellTemplate let-resumo>
                  <b>{{resumo.qtde | number}}</b>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Total vendido" field="total" [width]="250">
                <ng-template kendoGridCellTemplate let-resumo>
                  <span class="text-success">
                    <b>{{resumo.total | currency: "BRL"}}</b>
                  </span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-operadores')"></kendo-grid-excel>
            </kendo-grid>

            <div class="mt-2 mb-2"></div>
          </ng-template>
        </kendo-tabstrip-tab>

      </kendo-tabstrip>


    </div>

    <ng-container *ngIf="vendasDoDia">
      <h4>
        <button class="btn btn-outline-blue btn-rounded" (click)="voltarVendasDia()">
          <i class="fa fa-arrow-left ct-point  "></i>
        </button>
        Vendas do dia <span><b>{{vendasDoDia.dia}}</b></span></h4>
      <app-grid-pedidos #gridPedidos [pedidos]="vendasDoDia.pedidos" [carregando]="vendasDoDia.carregando" [mesa]="false"></app-grid-pedidos>

    </ng-container>

    <ng-container *ngIf="vendasProduto">
      <h4>
        <button class="btn btn-outline-blue btn-rounded" (click)="voltarVendasProdutos()">
          <i class="fa fa-arrow-left ct-point  "></i>
        </button>
        Vendas do produto <span><b>{{vendasProduto.nome}}</b></span></h4>

      <kendo-tabstrip class="nav-bordered mt-3" (tabSelect)="selecionouTabDetalheProduto($event)">
        <kendo-tabstrip-tab [title]="'Adicionais'" [selected]="vendasProdutoAbaAtiva === 'adicionais'">
          <ng-template kendoTabContent>
            <h5 class="mt-2">
              Vendas dos adicionais {{obtenhaDescricaoFiltro()}}</h5>

            <kendo-grid
              [style]=""
              [kendoGridBinding]="vendasProduto.adicionais"
              [loading]="carregandoAdicionaisProduto" style="min-height: 300">

              <kendo-grid-messages
                pagerPage="Página"
                pagerOf="de"
                pagerItems="itens"
                noRecords="nenhum adicional  "
                loading="Carregando"
                pagerItemsPerPage="ítems por página"
              >
              </kendo-grid-messages>
              <ng-template kendoGridToolbarTemplate>
                <button type="button" class="float-right" kendoGridExcelCommand icon="file-excel">Exportar para Excel</button>
              </ng-template>

              <kendo-grid-column title="produto" field="produto"   [width]="250"  >
                <ng-template kendoGridCellTemplate let-resumoAdicional  >
                  <span class="text-dark">{{resumoAdicional.produto}}</span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Adicional"   field="nome"   >
                <ng-template kendoGridCellTemplate let-resumoAdicional  >
                  <span class="text-dark">{{resumoAdicional.nome}}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Qtde"  [width]="150" field="qtde"  >
                <ng-template kendoGridCellTemplate let-resumoAdicional  >
                  <b>{{resumoAdicional.qtde | number}}</b>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Total"     [width]="250" field="total" >
                <ng-template kendoGridCellTemplate let-resumoAdicional  >
                    <span class="text-success">
                       <b>   {{resumoAdicional.total | currency: "BRL"}}</b>
                    </span>

                </ng-template>
              </kendo-grid-column>
              <kendo-grid-excel [fileName]="obtenhaNomeArquivo()"></kendo-grid-excel>
            </kendo-grid>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab [title]="'Combinações'" [selected]="vendasProdutoAbaAtiva === 'combinacoes'">
          <ng-template kendoTabContent>
            <h5 class="mt-2">
              Combinações de adicionais {{obtenhaDescricaoFiltro()}}</h5>

            <div class="mb-2">
              <span class="mr-3"><b>Qtde total:</b> {{resumoCombinacoesProduto.qtdeTotal | number}}</span>
              <span><b>Total adicionais:</b> {{resumoCombinacoesProduto.totalAdicionais | currency: "BRL"}}</span>
            </div>

            <kendo-grid
              [style]=""
              [kendoGridBinding]="resumoCombinacoesProduto.combinacoes"
              [loading]="carregandoCombinacoesProduto"
              style="min-height: 300">

              <kendo-grid-messages
                pagerPage="Página"
                pagerOf="de"
                pagerItems="itens"
                noRecords="nenhuma combinação no periódo"
                loading="Carregando"
                pagerItemsPerPage="ítems por página"
              >
              </kendo-grid-messages>

              <ng-template kendoGridToolbarTemplate>
                <button type="button" class="float-right" kendoGridExcelCommand icon="file-excel">Exportar para Excel</button>
              </ng-template>

              <kendo-grid-column title="Produto" field="produto" [width]="250">
                <ng-template kendoGridCellTemplate let-combinacao>
                  <span class="text-dark">{{combinacao.produto}}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Descrição" field="descricaoCombinacao">
                <ng-template kendoGridCellTemplate let-combinacao>
                  <span class="text-dark">{{combinacao.descricaoCombinacao}}</span>
                  <span class="badge badge-secondary ml-2" *ngIf="combinacao.semAdicionais">Sem adicionais</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Qtde" field="qtde" [width]="150">
                <ng-template kendoGridCellTemplate let-combinacao>
                  <b>{{combinacao.qtde | number}}</b>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Total" field="totalAdicionais" [width]="250">
                <ng-template kendoGridCellTemplate let-combinacao>
                  <span class="text-success"><b>{{combinacao.totalAdicionais | currency: "BRL"}}</b></span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-excel [fileName]="obtenhaNomeArquivoCombinacoes()"></kendo-grid-excel>
            </kendo-grid>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>

    </ng-container>
  </div>
</div>
